import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=4c4e6323&scoped=true&"
import script from "./LinkExpired.vue?vue&type=script&lang=js&"
export * from "./LinkExpired.vue?vue&type=script&lang=js&"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=4c4e6323&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e6323",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4e6323')) {
      api.createRecord('4c4e6323', component.options)
    } else {
      api.reload('4c4e6323', component.options)
    }
    module.hot.accept("./LinkExpired.vue?vue&type=template&id=4c4e6323&scoped=true&", function () {
      api.rerender('4c4e6323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/LinkExpired.vue"
export default component.exports